export const buildNumber = '20260506.2';
export const version = 'main';
export const latestCommit = '5810188b875fa9664d7d17406c2241d89683c7db';
